import React from 'react';
import { useNavigate } from 'react-router-dom';

import ArrowRight from '@/components/Icons/icons/ArrowRight';
import WarningIconNew from '@/components/Icons/icons/WarningIconNew';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import { timeAgo } from '@/utils/ts/stringUtils';

const EmailAccountUpdateFailureNotification = ({ body, email, handleSeen,seen,createdAt }) => {
  const navigate = useNavigate();

  return (
    <div className={`single-notification email-update-failure-notif cursor-pointer ${seen && 'seen'}`} onClick={handleSeen}>
      <div className='unread-dot'></div>
      <div className="avatar-div flex justify-center items-center">
        <IconContainer
          className="w-8 h-8 email-update-failure-notif-icon"
          icon={<WarningIconNew />}
          bgColor="var(--yellow-y-50)"
        />
      </div>
      <div className="text-div">
        <p className="description">{body}</p>
        <ButtonComponent
          variant="text-highlight"
          textStyle={{ fontSize: '14px', fontWeight: 500 }}
          style={{ padding: '12px 0 8px' }}
          onClick={() => {
            navigate(`/dashboard/settings?tab=connected-emails`, {
              state: {
                openModal: 'settings',
                email,
              },
            });
          }}
          rightIcon={<ArrowRight color="var(--icon-highlight)" />}>
          Reconnect{' '}
        </ButtonComponent>
        <p className="timestamp">
          {timeAgo(createdAt)}
        </p>
      </div>
    </div>
  );
};

export default EmailAccountUpdateFailureNotification;
